import { render, staticRenderFns } from "./MailTemplates.vue?vue&type=template&id=5d983542"
import script from "./MailTemplates.vue?vue&type=script&lang=js"
export * from "./MailTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports